import type { ReactNode } from 'react';

import {
  InfoIcon,
  StyledTooltip,
} from './HelpTooltip.styled.js';

export interface HelpTooltipProps {
  title: ReactNode | string;
  width?: number;
}

export const HelpTooltip = ({ title, width }: HelpTooltipProps) => {
  return (
    <StyledTooltip
      title={title}
      slotProps={{
        tooltip: {
          style: { maxWidth: width ?? 220 },
        },
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
    >
      <InfoIcon />
    </StyledTooltip>
  );
};
